import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpansionHeader',
  setup(__props) {


return { __sfc: true,Icon }
}

})